module.exports = __webpack_public_path__ + "static/media/Build.20105491.jpg";